import React from 'react';
import { Link } from 'react-router-dom';

function Infraestrutura() {
  return (
    <div className="container text-light mt-5 px-3">
      <div
        className="p-4 rounded-4 shadow-lg"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <h2 className="text-white mb-3 text-center">
          <i className="bi bi-hdd-network me-2 text-info"></i>
          Infraestrutura de Redes
        </h2>

        <p className="text-white-50 mb-4 text-center">
          Desenvolvemos e implementamos soluções completas em infraestrutura de rede, com foco em desempenho, estabilidade e segurança para ambientes empresariais de todos os portes.
        </p>

        <ul className="text-light fs-6">
          <li className="mb-3">
            <i className="bi bi-plug-fill me-2 text-primary"></i>
            <strong>Cabeamento estruturado:</strong> Projetos com CAT5e, CAT6 e fibra óptica para garantir alta taxa de transferência e confiabilidade.
          </li>
          <li className="mb-3">
            <i className="bi bi-router-fill me-2 text-success"></i>
            <strong>Equipamentos de rede:</strong> Instalação e configuração de switches, roteadores, access points e racks com identificação técnica.
          </li>
          <li className="mb-3">
            <i className="bi bi-house-gear-fill me-2 text-warning"></i>
            <strong>Gerenciamento lógico:</strong> Segmentação de rede com VLANs, monitoramento remoto e controle de acesso por IP e MAC.
          </li>
          <li className="mb-3">
            <i className="bi bi-shield-check me-2 text-danger"></i>
            <strong>Segurança de rede:</strong> Implantação de firewalls, autenticação segura e proteção contra intrusões (IDS/IPS).
          </li>
          <li className="mb-3">
            <i className="bi bi-building-gear me-2 text-light"></i>
            <strong>Ambientes corporativos e industriais:</strong> Soluções adaptadas para empresas, órgãos públicos, escolas, hospitais e plantas logísticas.
          </li>
        </ul>

        <div className="mt-4 text-center">
          <Link to="/contato" className="btn btn-outline-info btn-lg px-4">
            Solicitar projeto de rede
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Infraestrutura;
